module.exports = __webpack_public_path__ + "img/3_76.ac546041.png";